var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"stencil-size":{
      width: 350,
      height: 200,
    },"stencil-props":{
      handlers: {},
      movable: false,
      resizable: false,
    },"image-restriction":"stencil","src":_vm.inventory.src}}),_c('v-btn',{staticClass:"text-capitalize mt-2",attrs:{"block":"","color":"blue","dark":"","depressed":""},on:{"click":_vm.cropImage}},[_vm._v(" Set new profile picture ")]),_c('v-overlay',{attrs:{"absolute":true,"color":"white","opacity":".5","value":_vm.loading}},[_c('v-progress-circular',{staticClass:"mr-2",attrs:{"indeterminate":"","color":"#006341"}}),_c('b',{staticClass:"color_default"},[_vm._v("Loading...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }